// extracted by mini-css-extract-plugin
module.exports = {"profileHeader":"styles_profileHeader__gePg_","link":"styles_link__2JwyR","active":"styles_active__3NJXW","right":"styles_right__3-FtB"};